import { render } from "./Account.vue?vue&type=template&id=1dcbe132&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=1dcbe132&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcbe132"]])

export default __exports__